import { createFileRoute } from "@tanstack/react-router";

import { ContactId } from "@goose/schema/Salesforce";

export const Route = createFileRoute(
  "/_authenticated/admin/opportunity/$opportunityId/contact/$contactId",
)({
  params: {
    parse: ({ contactId }) => {
      return {
        contactId: ContactId.parse(contactId),
      };
    },
  },
});
